import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserDataTable from "../../../components/userAdminPanel/Components/UserDataTable/UserDataTable";
import { allUserAssetsColumns } from "../../../datatablesource";
import { handleUserError } from "../../../utils/error";
import userRequest from "../../../utils/userRequest";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import logo from "../../../images/accept.png";

import "../Styles/VerifiedAsset.scss";
import ViewportMeta from "../../../utils/ViewportMeta";
import { useTranslation } from "react-i18next";
// import DataTable from "../../../components/userAdminPanel/Components/UserDataTable/DataTable";
// import { DataTableContext } from "../../../context/DataTableContext";
// import Barcode from "react-barcode";
// import { QRCodeSVG } from "qrcode.react";

const PrintingAsset2 = () => {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [allAssetsList, setAllAssetsList] = useState([]);
  // const {
  //   rowSelectionModel,
  //   setRowSelectionModel,
  //   tableSelectedRows,
  //   setTableSelectedRows,
  //   setTableSelectedExportRows,
  // } = useContext(DataTableContext);

  const getAllAssetsList = async () => {
    try {
      userRequest
        .get("/GetAllAssetMasterEncodeAssetCaptureFinal", data)
        .then((response) => {
          console.log(response?.data, "--------------");
          const sortedData = response.data.sort(
            (a, b) =>
              new Date(b.assetdatecaptured) - new Date(a.assetdatecaptured)
          );
          setAllAssetsList(response?.data ?? []);
          setIsAuthenticating(false);
        })
        .catch((error) => {
          handleUserError(error);
          console.error(error);
          setIsAuthenticated(false);
        });
    } catch (error) {
      console.log(error);
      setIsAuthenticated(false);
      setIsAuthenticating(false);
      // navigate("/userLogin");
    }
  };

  useEffect(() => {
    getAllAssetsList();
  }, []);

  // const handleView = (row) => {
  //   console.log(row);
  //   // navigate("/member/view-gtin-product/" + row?.id);
  // };

  // const handlePrint = () => {
  //   if (tableSelectedRows.length === 0) {
  //     alert("Please select a row to print.");
  //     return;
  //   }
  //   // Open a new window/tab with only the QR code
  //   const printWindow = window.open("", "Print Window", "height=400,width=800");
  //   const html =
  //     "<html><head><title>Dynamic Data Barcode</title>" +
  //     "<style>" +
  //     "@page { size: 2in 1in; margin: 0; }" +
  //     "body { font-size: 13px; line-height: 0.4; }" +
  //     // "#logo { height: 25px; width: 100px; margin-left:40px; display: flex; justify-content: center; align-items: center;visibility: hidden; }" +
  //     "#paragh { font-size: 8px; font-weight: 400; display: flex; justify-content: center; align-items: start; }" +
  //     "</style>" +
  //     "</head><body>" +
  //     '<div id="logo"></div>' + // Ensure the logo container is in the HTML
  //     '<div id="barcode"></div>' +
  //     '<div id="qrcode"></div>' +
  //     '<p id="parag"></p>' +
  //     "</body></html>";

  //   printWindow.document.write(html);
  //   const barcodeContainer =
  //     printWindow.document.getElementById("printBarcode");
  //   const barcode = document.getElementById("barcode").cloneNode(true);
  //   barcodeContainer.appendChild(barcode);

  //   const logoImg = new Image();
  //   logoImg.src = logo;

  //   logoImg.onload = function () {
  //     // printWindow.document.getElementById('imglogo').src = logoImg.src;
  //     printWindow.print();
  //     printWindow.close();
  //     setTimeout(() => {
  //       setTableSelectedRows([]);
  //       setRowSelectionModel([]);
  //     }, 500);
  //   };
  // };

  // const handleRowClickInParent = (item) => {
  //   console.log("checking ", item);
  //   if (!item || item?.length === 0) {
  //     // setTableSelectedRows(data)
  //     setTableSelectedExportRows(item);
  //     return;
  //   }

  //   const barcodes = item.map((row) => row.barcode);
  //   console.log(barcodes);
  //   setTableSelectedRows(barcodes);
  // };

  return (
    <>
      <div
        className={`p-0 h-full ${
          i18n.language === "ar" ? "sm:mr-72" : "sm:ml-72"
        }`}
      >
        <ViewportMeta />
        <UserDataTable data={allAssetsList} columnsName={allUserAssetsColumns(t)} secondaryColor='secondary'
          title={t("VERIFIED ASSETS")} backButton={true}
          loading={isAuthenticating}
          globalSearch={true}
          deleteBtnEndPoint="/DeleteAssetMasterEncodeAssetCaptureFinalById"
          UniqueId="verifiedAssetId"
        />

        {/* <div className="flex justify-end items-end w-full px-6 mt-3">
          <p
            onClick={handlePrint}
            className="bg-secondary text-white py-2 px-3 rounded-md font-sans hover:bg-primary hover:font-semibold cursor-pointer"
          >
            Print Asset
          </p>
        </div>
        <DataTable
          data={allAssetsList}
          columnsName={allUserAssetsColumns(t)}
          title={t("VERIFIED12 ASSETS")}
          loading={isAuthenticating}
          secondaryColor="secondary"
          // globalSearch={true}
          handleRowClickInParent={handleRowClickInParent}
          uniqueId="memberInvoiceId"
          dropDownOptions={[
            {
              label: "View",
              icon: (
                <VisibilityIcon
                fontSize="small"
                color="action"
                style={{ color: "rgb(37 99 235)" }}
                />
              ),
              action: handleView,
            },
            {
              label: `${t("Edit")}`,
              icon: (
                <EditIcon
                fontSize="small"
                color="action"
                style={{ color: "rgb(37 99 235)" }}
                />
              ),
              // action: handleEdit
            },
            {
              label: "Delete",
              icon: (
                <DeleteIcon fontSize="small" style={{ color: "#FF0032" }} />
              ),
              // action: handleDelete,
            },
          ]}
        /> */}

        {/* Generate barcodes for selected rows */}
        {/* {tableSelectedRows.map((selectedRow, index) => (
          <div id="barcode" className="hidden" key={index}>
            <img id="logo" className="" src={companyLogo} alt="" />
            <Barcode
              value={selectedRow.data.TagNumber}
              height={15}
              width={1.3}
              margin={5}
              fontSize={12}
            />
            <QRCodeSVG
              id="qrcode"
              value={`${selectedRow.data.TagNumber} - ${selectedRow.data.MinorCategoryDescription}`}
              height={25}
              width={30}
            />
            <p id="paragh">{selectedRow.data.aSSETdESCRIPTION}</p>
          </div>
        ))} */}
      </div>
    </>
  );
};

export default PrintingAsset2;
